import type {
    ResponsibleRule,
    SensitiveRule
} from '@idea2app/ai-work-order-service';
import { Filter } from 'mobx-restful';

import { TableModel } from './Base';
import userStore from './User';

export type RuleType = 'sensitive' | 'responsible';

export class RuleModel<
    T extends SensitiveRule | ResponsibleRule
> extends TableModel<T, Filter<T>> {
    baseURI = '';
    client = userStore.client;

    constructor(public ruleType: RuleType) {
        super();
        this.baseURI = `/rule/${ruleType}`;
    }
}

export const sensitiveRuleStore = new RuleModel<SensitiveRule>('sensitive');
export const responsibleRuleStore = new RuleModel<ResponsibleRule>(
    'responsible'
);
